<template>
    <div>
        <multiselect id="myBtn" v-model="value" label="mobile_name" :placeholder="translations.filter" :closeOnSelect="true" :close-on-select="true" :options="options" :taggable="true" :searchable="false" :show-labels="false" :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.mobile_name }}</strong></template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: "dv5-multiselect",
    components: {
        Multiselect
    },
    props: {
        view: {
            type: Array,
        },
        toolsSelected: {
            type: Function
        },
        translations: null
    },
    data () {
        return {
            value: null,
            options: [{}]
        }
    },
    mounted() {
        this.options = this.view;
    },
    methods: {
        getImagePath(filterSelected) {
            this.toolsSelected(filterSelected)
        }
    },
    watch: {
        value(newValue, oldValue) {
            let filterSelected = null
            if (newValue === null) {
                filterSelected = 0
            } else if ( newValue != null ) {
                filterSelected = this.options.indexOf(newValue)
            }
            this.getImagePath(filterSelected);
        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.multiselect {
    min-width: 15rem !important;
    margin: 0 2%;
}
.multiselect__tags {
    min-height: 48px;
    padding-top: 12px;
}
.multiselect__option--highlight {
    background: #0080FC;
}
.multiselect__option--selected.multiselect__option--highlight{
    background: #707070;
}
.multiselect--above .multiselect__content-wrapper {
    bottom: auto !important;
}

</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/lib/dv5-multiselect.vue